import { render, staticRenderFns } from "./taskCreate.vue?vue&type=template&id=edd199f2&"
import script from "./taskCreate.vue?vue&type=script&lang=js&"
export * from "./taskCreate.vue?vue&type=script&lang=js&"
import style0 from "./taskCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports